import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceEvent {
    lookupService = new APIServiceLookUp();

    async getAllEvent(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}event/getAllEvent`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setEvent(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}event/setEvent`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateEvent(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}event/updateEvent`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delEvent(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}event/delEvent`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}
